import { useState, useEffect, useRef, useCallback } from 'react';
import { cn } from '~/utils/';
import BackToDashboard from "~/components/Nav/BackToDashboard";
import NewChat from "~/components/Nav/NewChat";
import { LuPanelLeft } from 'react-icons/lu';
import { useGetConversationsQuery } from '~/data-provider';
import Spinner from '../svg/Spinner';
import Conversation from "~/components/Conversation";
import Upgrade from "~/components/Nav/Upgrade";
import { useNavigate } from 'react-router-dom';
import { HiMenuAlt2 } from "react-icons/hi";
import { conversationList } from '~/helpers/store';
import { MdNavigateNext, MdNavigateBefore } from "react-icons/md";
import { hasSubscription } from "~/utils/user";

export default function Nav({ navVisible, setNavVisible }) {
  const [isHovering, setIsHovering] = useState(false);
  const [srVisible, setSrVisible] = useState(true);
  const containerRef = useRef(null);
  const cState = conversationList((state) => state);
  const navigate = useNavigate();

  useEffect(()=>{
    cState.setConvoLoad(true);
    // data provider
    useGetConversationsQuery(cState.pageNumber).then((data) => {
      cState.setConversation(data['conversations']);
      cState.setTotalPage(data['pages']);
      cState.setConvoLoad(false);
    });
  }, [cState.pageNumber])

  const toggleNavVisible = useCallback(() => {
    setNavVisible((prev: boolean) => !prev);
  }, [navVisible]);

  return (
    <>
      <div
        className={cn(
          'min-h-nav fixed h-full md:inset-y-0 nav-container',
					navVisible ? 'w-[270px]' : 'w-[30px] h-nav',
        )}
      >
        <div
          className={cn(
            'nav h-full max-w-[240px] flex-col overflow-hidden ',
						navVisible ? '' : 'w-0',
          )}
        >
          <div className="scrollbar-trigger relative flex h-full max-w-[260px] flex-1 items-start border-white/20">
            <nav className="relative flex h-full flex-1 flex-col space-y-2 px-2 py-4">
              <div className="flex items-center mb-2 logo-container">
                <img
                  src="/assets/chatpdfv2-logo.png"
                  alt="ChatPDF"
                  width="25"
                  className="block"
                />
                <span className="ml-2 text-[20px] font-bold text-gray-900">
                  ChatPDF
                </span>
              </div>
              <NewChat/>
              <div className="mx-1 px-1 py-3 font-semibold "
              style={{
                borderTop: "1px solid #00000026"
              }}>
                Chat History
              </div>
              <div
                className={cn(
                  'scrollbar-transparent max-w-[228px] flex-1 flex-col overflow-y-auto',
                  {
                    'scrollbar-hide': !isHovering,
                  },
                )}
                onMouseEnter={() => setIsHovering(true)}
                onMouseLeave={() => setIsHovering(false)}
                ref={containerRef}
              >
                <div
                  className={cn('flex flex-col gap-1 text-sm')}
                > 
                  { cState.convoLoad ? 
                    <Spinner className="m-auto mt-5" /> :
                    cState.conversation && cState.conversation.length ?
                      cState.conversation.map((convo) => {
                        return (
                          <>
                          <Conversation
                            conversation={convo}
                          />
                          </>
                        );
                      })
                      :
                      <>
                      <div className="text-center no-chat">
                        <img src="/assets/no-chat.svg"></img>
                        <div>No chats available.</div>
                        <div><span className="create" onClick={()=>{
                          navigate('/chat/new');
                          if(document.querySelector('.landing-container')) document.querySelector('.landing-container').scrollTop = 0;
                        }}>Create</span> one to get started.</div>
                      </div>
                      </>
                  }
                </div>
              </div>
              { cState.conversation && cState.conversation.length && cState.totalPage > 1 ?
              <div className="convo-page-controls">
                { cState.pageNumber > 1 ?
                <span onClick={() => {
                  cState.setPageNumber(cState.pageNumber - 1)
                }}><MdNavigateBefore /></span> : <span className="text-gray-300"><MdNavigateBefore /></span> }
                <span className="font-size-custom"> {cState.pageNumber} / {cState.totalPage}</span>
                { cState.pageNumber < cState.totalPage ?
                <span onClick={() => {
                  cState.setPageNumber(cState.pageNumber + 1)
                }}><MdNavigateNext /></span> : <span className="text-gray-300"><MdNavigateNext /></span> }
              </div> : 
              <></> 
              }
              {(!hasSubscription()) && (<Upgrade></Upgrade>) }
              <BackToDashboard />
            </nav>
          </div>
        </div>
        <button
          type="button"
          className={cn(
            'group absolute top-4 z-10 block h-4 w-4 items-center justify-center rounded-md text-gray-400 hover:text-gray-500',
            navVisible ? 'mr-10 right-1' : 'ml-2 right-2'
          )}
          onClick={() => {
            toggleNavVisible();
            setSrVisible(false);
          }}
          onMouseEnter={() => setSrVisible(true)}
          onMouseLeave={() => setSrVisible(false)}
        >
          {srVisible && (
            <span className="pointer-events-none absolute left-7 top-1/2 z-10 hidden h-max w-max -translate-y-1/2 overflow-visible whitespace-nowrap rounded bg-gray-300 px-2 py-1.5 text-sm text-black opacity-0 [clip:_unset] group-hover:opacity-100 dark:bg-gray-900 dark:text-white/90 sm:block">
              <span className="absolute -left-1 top-1/2 -z-10 block h-2.5 w-2.5 -translate-y-1/2 rotate-45 bg-inherit" />
              {navVisible ? 'Close' : 'Open'} sidebar
            </span>
          )}
          <span className={cn(navVisible ? '' : 'hidden')}>
            <LuPanelLeft size={20} />
          </span>
          <span className={cn(navVisible ? 'hidden' : '')}>
            <HiMenuAlt2 size={20} />
          </span>
        </button>
      </div>
    </>
  );
}
